import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as BrandLogo } from '../../assets/logo/logo-centralis-blanc.svg';
import './Footer.css';

// Liens externes (asset PDF + contact) : memes cibles que le footer marketing de l'accueil.
const GUIDE_PDF = "/pdfs/guides/25-12-12 Guide d'utilisation V3.pdf";
const CONTACT_MAILTO = 'mailto:contact@centralis-europe.com';

/**
 * Footer global de l'application, monte par MainLayout sur toutes les pages dotees
 * de la navbar (acheteur + prestataire + pages legales). Reprend les liens reels
 * existants (routes verifiees dans App.tsx) et accueille Assistance + Mentions,
 * retires du menu deroulant de la navbar.
 */
const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-brand">
          <BrandLogo className="app-footer-logo" />
          <p className="app-footer-tagline">
            Centrale nationale d'achats publics dédiée à la rénovation de patrimoine.
          </p>
        </div>

        <nav className="app-footer-cols" aria-label="Pied de page">
          <div className="app-footer-col">
            <h3 className="app-footer-col-title">Plateforme</h3>
            <Link className="app-footer-link" to="/">Accueil</Link>
            <Link className="app-footer-link" to="/annuaire">Annuaire</Link>
            <Link className="app-footer-link" to="/publications">Publications</Link>
          </div>

          <div className="app-footer-col">
            <h3 className="app-footer-col-title">Assistance</h3>
            <Link className="app-footer-link" to="/assistance">Tutoriels</Link>
            <a className="app-footer-link" href={GUIDE_PDF} target="_blank" rel="noopener noreferrer">
              Guide méthodologique
            </a>
            <a className="app-footer-link" href={CONTACT_MAILTO}>Nous contacter</a>
          </div>

          <div className="app-footer-col">
            <h3 className="app-footer-col-title">Légal</h3>
            <Link className="app-footer-link" to="/mentions-legales">Mentions légales</Link>
            <Link className="app-footer-link" to="/cg">Conditions générales</Link>
            <Link className="app-footer-link" to="/securite">Politique de sécurité</Link>
          </div>

          <div className="app-footer-col">
            <h3 className="app-footer-col-title">Engagements</h3>
            <Link className="app-footer-link" to="/charte-rse">Charte RSE</Link>
            <Link className="app-footer-link" to="/charte-deontologie">Charte Déontologie</Link>
            <Link className="app-footer-link" to="/charte-achats">Charte Achats durables</Link>
          </div>
        </nav>
      </div>

      <div className="app-footer-bottom">
        <span>© {year} Centralis — Tous droits réservés.</span>
      </div>
    </footer>
  );
};

export default Footer;
